import { androidDownloadLink, iosDownloadLink } from 'shared/constants';
import { UAParser } from 'ua-parser-js';

const storeLinkByOs: Record<string, string> = {
  iOS: iosDownloadLink,
  Android: androidDownloadLink,
};

export const getMobileStoreLink = (): string | null => {
  const { name } = new UAParser().getOS();
  if (!name) {
    return null;
  }
  return storeLinkByOs[name] ?? null;
};
